import { type ComponentProps, useLayoutEffect, useMemo } from 'react'
import { useRouteMatch } from 'react-router'
import { useLocation } from 'react-router-dom'

import LocaleAwareRoute from 'components/App/Routes/LocaleAwareRoute'
import { registerPageView } from 'actions/AnalyticsActions'
import { useAppDispatch } from 'hooks/reduxHooks'
import { matchLocaleAwarePath } from 'lib/routing/matchLocaleAwarePath'

interface Props extends ComponentProps<typeof LocaleAwareRoute> {}

function TrackedRoute(props: Props) {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const fallbackMatch = useRouteMatch()
  const match = props.path ? matchLocaleAwarePath(location.pathname, props) : fallbackMatch
  const matchPath = match?.path
  const matchParamsKey = JSON.stringify(match?.params ?? {})
  const matchParams = useMemo<Record<string, string | undefined>>(() => JSON.parse(matchParamsKey), [matchParamsKey])
  const matchUrl = match?.url
  const search = props.location?.search ?? location.search

  useLayoutEffect(() => {
    if (matchPath && matchUrl) {
      dispatch(registerPageView({
        template: matchPath,
        params: matchParams ?? {},
        path: matchUrl,
        search,
      }))
    }
  }, [
    dispatch,
    matchParams,
    matchPath,
    matchUrl,
    search,
  ])

  return <LocaleAwareRoute {...props} />
}

export default TrackedRoute
